import { mutationTypes, actionTypes } from 'BASE/store/types'

export default {
    props: {
        dialog: Object,
    },
    data: function () {
        return {
            inputMessage: "",
            errorMessage: "",
        }
    },
    methods: {
        confirm: async function () {
            const loader = this.$loading.show();
            this.errorMessage = await this.$store.dispatch(actionTypes.CHAT_SET_GROUP_ROOM_NAME, {
                roomId: this.dialog.data.roomId,
                roomName: this.inputMessage,
                connectionParams: {
                    waitConnected: true,
                },
            });
            loader.hide();

            if (!this.errorMessage) {
                this.cancel();
            }
        },
        cancel: function () {
            this.inputMessage = "";
            this.errorMessage = "";
            this.dialog.$emit('close');
        },
    },
    watch: {
        "dialog.isOpen": {
            //開啟時都重新初始化資料，如需預設原群組名需額外多傳送roomName即可添加預設
            handler(newValue, oldValue) {
                if(newValue && this.dialog.data.roomName){
                    this.inputMessage = this.dialog.data.roomName;
                }
            }
        }
    }
};